import {createRouter, createWebHistory} from 'vue-router';
import ScrollTarget from "../elements/ScrollTarget";
import PageProfile from "../views/PageProfile";
import PageReport from "../views/PageReport";
import ArticleCustomerFocus from "@/views/ArticleCustomerFocus";
import ArticleInnovation from "@/views/ArticleInnovation";
import ArticleReliability from "@/views/ArticleReliability";
import ArticleSustainability from "@/views/ArticleSustainability";
import PageSustainability from "@/views/PageSustainability";

const routes = [
  {
    path: '/',
    name: 'Home',
    component: ScrollTarget,
    meta: {
      title: "enercity Geschäftsbericht 2020",
    }
  },
  {
    path: '/profil/',
    name: 'Profil',
    component: ScrollTarget
  },
  {
    path: '/profil/details/',
    name: 'Profil Details',
    component: PageProfile,
    meta: {
      title: 'Worauf wir stolz sind - enercity Geschäftsbericht 2020',
      description: 'Lernen Sie unsere Vision, unsere Mission und unsere Strategie kennen. Und erfahren Sie, welche Produkte und Dienstleistungen wir unseren Kunden anbieten.',
      metaTags: [
        {
          name: 'description',
          content: "Lernen Sie unsere Vision, unsere Mission und unsere Strategie kennen. Und erfahren Sie, welche Produkte und Dienstleistungen wir unseren Kunden anbieten."
        },
        {
          name: 'og:url',
          content: 'https://www.enercity.de/geschaeftsbericht/2020/profil/details'
        },
        {
          name: 'og:site_name',
          content: 'Worauf wir stolz sind - enercity Geschäftsbericht 2020'
        },
        {
          name: 'og:title',
          content: 'Worauf wir stolz sind'
        },
        {
          name: 'og:description',
          content: 'Lernen Sie unsere Vision, unsere Mission und unsere Strategie kennen. Und erfahren Sie, welche Produkte und Dienstleistungen wir unseren Kunden anbieten.'
        },
        {
          name: 'og:image',
          content: 'https://www.enercity.de/geschaeftsbericht/2020/og-profil.jpg'
        }
      ]
    }
  },
  {
    path: '/chronik/',
    name: 'Chronik',
    component: ScrollTarget
  },
  {
    path: '/werte/',
    name: 'Werte',
    component: ScrollTarget
  },
  {
    path: '/finanzbericht/',
    name: 'Finanzbericht',
    component: ScrollTarget
  },
  {
    path: '/finanzbericht/details/',
    name: 'Finanzbericht Bilanz',
    component: PageReport,
    meta: {
      title: 'Außergewöhnlich erfolgreich - enercity Geschäftsbericht 2020',
      metaTags: [
        {
          name: 'description',
          content: "Unsere an starken Werten orientierte Unternehmensstrategie hat sich auch 2020 unter außergewöhnlichen Rahmenbedingungen bewährt."
        },
        {
          name: 'og:url',
          content: 'https://www.enercity.de/geschaeftsbericht/2020/finanzbericht/details'
        },
        {
          name: 'og:site_name',
          content: 'Außergewöhnlich erfolgreich - enercity Geschäftsbericht 2020'
        },
        {
          name: 'og:title',
          content: 'Außergewöhnlich erfolgreich'
        },
        {
          name: 'og:description',
          content: 'Unsere an starken Werten orientierte Unternehmensstrategie hat sich auch 2020 unter außergewöhnlichen Rahmenbedingungen bewährt.'
        },
        {
          name: 'og:image',
          content: 'https://www.enercity.de/geschaeftsbericht/2020/og-finanzbericht.jpg'
        }
      ]
    }
  },
  {
    path: '/nachhaltigkeitsbericht/',
    name: 'Nachhaltigkeitsbericht',
    component: PageSustainability,
    meta: {
      title: 'Nachhaltigkeit bei enercity - enercity Geschäftsbericht 2020',
      metaTags: [
        {
          name: 'description',
          content: "Als Energiedienstleister hat enercity nicht nur eine besondere Verantwortung, sondern auch eine große Chance, den Umbau des Energiesystems voranzutreiben."
        },
        {
          name: 'og:url',
          content: 'https://www.enercity.de/geschaeftsbericht/2020/nachhaltigkeitsbericht'
        },
        {
          name: 'og:site_name',
          content: 'Nachhaltigkeit bei enercity - enercity Geschäftsbericht 2020'
        },
        {
          name: 'og:title',
          content: 'Nachhaltigkeit bei enercity'
        },
        {
          name: 'og:description',
          content: 'Als Energiedienstleister hat enercity nicht nur eine besondere Verantwortung, sondern auch eine große Chance, den Umbau des Energiesystems voranzutreiben.'
        },
        {
          name: 'og:image',
          content: 'https://www.enercity.de/geschaeftsbericht/2020/og-nachhaltigkeitsbericht.jpg'
        }
      ]
    }
  },
  {
    path: '/kundenorientierung/',
    name: 'Kundenorientierung',
    component: ArticleCustomerFocus,
    meta: {
      title: 'So leicht ist das – mit enercity! enercity Geschäftsbericht 2020',
      metaTags: [
        {
          name: 'description',
          content: "Ihre Ansprüche sind unterschiedlich, doch eines haben unsere Kunden gemeinsam: Mit enercity haben sie ganz einfach ihre persönliche Energielösung gefunden."
        },
        {
          name: 'og:url',
          content: 'https://www.enercity.de/geschaeftsbericht/2020/kundenorientierung'
        },
        {
          name: 'og:site_name',
          content: 'So leicht ist das – mit enercity! enercity Geschäftsbericht 2020'
        },
        {
          name: 'og:title',
          content: 'So leicht ist das – mit enercity!'
        },
        {
          name: 'og:description',
          content: 'Ihre Ansprüche sind unterschiedlich, doch eines haben unsere Kunden gemeinsam: Mit enercity haben sie ganz einfach ihre persönliche Energielösung gefunden.'
        },
        {
          name: 'og:image',
          content: 'https://www.enercity.de/geschaeftsbericht/2020/og-kundenorientierung.jpg'
        }
      ]
    }
  },
  {
    path: '/innovation/',
    name: 'Innovation',
    component: ArticleInnovation,
    meta: {
      title: 'Unsere Ideen für die Energiewelt von morgen - enercity Geschäftsbericht 2020',
      metaTags: [
        {
          name: 'description',
          content: "Egal, wie verrückt sie zunächst klingt: Jede Idee kann großes Potenzial haben. Erfahren Sie, wie enercity diesen Grundsatz lebt!"
        },
        {
          name: 'og:url',
          content: 'https://www.enercity.de/geschaeftsbericht/2020/innovation'
        },
        {
          name: 'og:site_name',
          content: 'Unsere Ideen für die Energiewelt von morgen - enercity Geschäftsbericht 2020'
        },
        {
          name: 'og:title',
          content: 'Unsere Ideen für die Energiewelt von morgen'
        },
        {
          name: 'og:description',
          content: 'Egal, wie verrückt sie zunächst klingt: Jede Idee kann großes Potenzial haben. Erfahren Sie, wie enercity diesen Grundsatz lebt!'
        },
        {
          name: 'og:image',
          content: 'https://www.enercity.de/geschaeftsbericht/2020/og-innovation.jpg'
        }
      ]
    }
  },
  {
    path: '/verlaesslichkeit/',
    name: 'Verlässlichkeit',
    component: ArticleReliability,
    meta: {
      title: 'Hannover wird smart, nachhaltig und lebenswert - enercity Geschäftsbericht 2020',
      metaTags: [
        {
          name: 'description',
          content: "Städte verändern sich. Eines bleibt gleich: Auch in Zukunft können die Menschen in Hannover sich auf enercity verlassen."
        },
        {
          name: 'og:url',
          content: 'https://www.enercity.de/geschaeftsbericht/2020/verlaesslichkeit'
        },
        {
          name: 'og:site_name',
          content: 'Hannover wird smart, nachhaltig und lebenswert - enercity Geschäftsbericht 2020'
        },
        {
          name: 'og:title',
          content: 'Hannover wird smart, nachhaltig und lebenswert'
        },
        {
          name: 'og:description',
          content: 'Städte verändern sich. Eines bleibt gleich: Auch in Zukunft können die Menschen in Hannover sich auf enercity verlassen.'
        },
        {
          name: 'og:image',
          content: 'https://www.enercity.de/geschaeftsbericht/2020/og-verlaesslichkeit.jpg'
        }
      ]
    }
  },
  {
    path: '/nachhaltigkeit/',
    name: 'Nachhaltigkeit',
    component: ArticleSustainability,
    meta: {
      title: 'Grüne Wärme für Hannover - enercity Geschäftsbericht 2020',
      metaTags: [
        {
          name: 'description',
          content: "Regional, dezentral, grün: Die Wärmeversorgung der Zukunft ohne fossile Brennstoffe. Lesen Sie, enercity das Fernwärmenetz umgestaltet und CO2 einspart."
        },
        {
          name: 'og:url',
          content: 'https://www.enercity.de/geschaeftsbericht/2020/nachhaltigkeit'
        },
        {
          name: 'og:site_name',
          content: 'Grüne Wärme für Hannover - enercity Geschäftsbericht 2020'
        },
        {
          name: 'og:title',
          content: 'Grüne Wärme für Hannover'
        },
        {
          name: 'og:description',
          content: 'Regional, dezentral, grün: Die Wärmeversorgung der Zukunft ohne fossile Brennstoffe. Lesen Sie, enercity das Fernwärmenetz umgestaltet und CO2 einspart.'
        },
        {
          name: 'og:image',
          content: 'https://www.enercity.de/geschaeftsbericht/2020/og-nachhaltigkeit.jpg'
        }
      ]
    }
  }
];

const router = createRouter({
  history: createWebHistory('/geschaeftsbericht/2020/'),
  routes
});

export default router;
